import { useProfileStore } from "@/state/profile";

export function SpeakButton({ text, label = "Escuchar" }: { text: string; label?: string }) {
  const muted = useProfileStore((state) => state.soundMuted);
  if (!("speechSynthesis" in window) || muted || !text.trim()) return null;
  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        speechSynthesis.cancel();
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = "es-ES";
        utterance.rate = 0.85;
        speechSynthesis.speak(utterance);
      }}
      className="pill normal-case tracking-normal"
      aria-label={`${label}: ${text}`}
    >
      🔊 {label}
    </button>
  );
}
